import Tabs from './tabs';
import Pane from './pane';

export {
	Tabs,
	Pane
};


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/shared/tabs/index.js